/** β で重み付けしたバンピック率を勝率に足す理由 */
export function TierCalculationWhyBeta() {
  return (
    <div className="win-rate-pick-scatter__panel">
      <h3 className="win-rate-pick-scatter__panel-title">なぜ β で重み付けしたバンピック率を足すか</h3>
      <p>
        評価の高いヒーローは早めにピックされやすく、カウンターピックなどされて勝率が低めに算出されることが予想されます。
      </p>
      <p>
        一方でピックが限定的なヒーローは、刺さるタイミングでだけピックされて勝率が高く見えることもあります。
      </p>
      <p>
        β はこの勝率の偏りを調整するための係数です。
      </p>
    </div>
  );
}
